import { CART_FETCHING, CART_SUCCESS } from 'store/actionTypes/addToCart'

export const changeCartActionFetching = () => ({
  type: CART_FETCHING,
})
export const changeCartActionSuccess = (payload) => ({
  type: CART_SUCCESS,
  payload,
})
